import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconInfo: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg height={$size} viewBox="0 0 2 13" xmlns="http://www.w3.org/2000/svg">
      <path d="m16 13v9h-2v-9zm0-4v2h-2v-2z" fill="#132122" fillRule="evenodd" transform="translate(-14 -9)" />
    </svg>
  </IconStyled>
);

IconInfo.defaultProps = iconDefaultProps;
IconInfo.displayName = 'IconInfo';

export default IconInfo;
